<template>
  <div class="cast-wrapper">
    <div class="cast" :style="cssProps">
      <img id="first" src="../assets/cast.png" />
      <img id="second" src="../assets/cast.png" />
      <img id="third" src="../assets/cast.png" />
      <img id="forth" src="../assets/cast.png" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  conputed: {
    cssProps() {
      return {
        "--time": "10s",
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.cast {
  position: relative;
  height: 50vh;
  width: 100vw;
  overflow: hidden;
  background: #000;

  img {
    width: 100vw;
    position: absolute;
  }

  #first {
    animation: firstmove 180s infinite linear;
    animation-fill-mode: forwards;
  }

  #second {
    animation: secondmove 180s infinite linear;
    top: 100%;
  }

  #third {
    top: 100%;
    animation: secondmove 180s infinite linear;
    animation-delay: 60s;
  }

  #forth {
    top: 100%;
    animation: secondmove 180s infinite linear;
    animation-delay: 120s;
  }

  @keyframes firstmove {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(0, -300%);
    }
  }

  @keyframes secondmove {
    0% {
      transform: translate(0, 100%);
    }
    100% {
      transform: translate(0, -200%);
    }
  }
}
</style>
